import cashBookInstance from '../../cashBook/instance'

const acceptInitialBalance = (data) => {
	return cashBookInstance.post('/cash-book/initial-balance', data)
}

export default acceptInitialBalance
